import TableBodyUploadHistory from './TableBodyUploadHistory';

export default TableBodyUploadHistory;
